import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LettuceTalkLogo from "../images/logo.png";
import GoogleSignInButton from "./GoogleSignInButton";
import { useAuth } from "../contexts/AuthContext";
import OrderButton from "./OrderButton";
import UserIcon from "./icons/UserIcon";
import AnalyticsSettingsLink from "./AnalyticsSettingsLink";

const MAINTENANCE_MODE = true; // Set to true to hide GoogleSignInButton everywhere

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);
  const navigate = useNavigate();
  const { currentUser, logout, signInWithGoogle } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      setIsMenuOpen(false);
      navigate("/app-landing", { replace: true });
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  const handleSignInSuccess = async (user) => {
    try {
      await user.reload(); // ensure up-to-date photoURL
    } catch (err) {
      console.error("Error reloading user:", err);
    }
    setIsMenuOpen(false);
  };

  const handleSignInError = (error) => {
    if (!error.ignoreError) {
      console.error("Sign in error:", error);
    }
  };

  return (
    <div className="px-4 min-h-12 fixed top-0 w-full flex flex-row items-center justify-center bg-white shadow-md z-10">
      <div className="flex-1">
        <Link to="/refine" className="flex items-center gap-2" aria-label="Create a card">
          <img src={LettuceTalkLogo} alt="LettuceTalk Logo" className="w-8" />
          <span className="font-title font-bold text-darkgreen text-xl hidden sm:block">LettuceTalk</span>
        </Link>
      </div>

      <div className="flex flex-row justify-center items-center">
        {currentUser ? (
          <div className="dropdown dropdown-end">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost btn-circle avatar"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div
                key={currentUser.photoURL || currentUser.uid}
                className="w-8 h-8 rounded-full overflow-hidden bg-gray-400 text-white flex items-center justify-center"
              >
                {!imageFailed && currentUser.photoURL ? (
                  <img
                    src={currentUser.photoURL}
                    alt={currentUser.displayName || "User profile"}
                    className="w-full h-full object-cover"
                    onError={() => setImageFailed(true)}
                  />
                ) : (
                  <UserIcon className="text-white p-1" />
                )}
              </div>
            </div>
            {isMenuOpen && (
              <ul
                tabIndex={0}
                className="mt-3 z-50 p-2 shadow menu menu-sm dropdown-content bg-base-100 rounded-box w-52"
              >
                <li className="p-2 text-sm opacity-75">
                  Signed in as <span className="font-bold">{currentUser.displayName || currentUser.email}</span>
                </li>
                <li><Link to="/home" onClick={() => setIsMenuOpen(false)}>My Decks</Link></li>
                <li><Link to="/privacy" onClick={() => setIsMenuOpen(false)}>Privacy</Link></li>
                <li><AnalyticsSettingsLink className="block px-3 py-2 text-left text-sm" /></li>
                <li><button onClick={handleLogout}>Sign Out</button></li>
              </ul>
            )}
          </div>
        ) : (
          <div className="flex flex-row">
            <OrderButton className="mx-2 btn-sm" />
            {!MAINTENANCE_MODE && (
              <GoogleSignInButton
                className="btn-sm"
                onClick={signInWithGoogle}
                onSuccess={handleSignInSuccess}
                onError={handleSignInError}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
